import React from 'react';
import SarDefaultInfoButton from './SarDefaultInfoButton';

const DefaultHeaderDetails = ({ hasError = false, label, headerLabelClassName }: Props) => {
  return (
    <div className={`flex flex-col gap-y-1`}>
      <div className={'flex items-center gap-x-1 justify-start'}>
        <span className={`text-xs tracking-wide ${hasError ? 'text-f-red-1' : 'text-f-black-2'}`}>Information</span>
        <SarDefaultInfoButton hasError={hasError} onStopPropagation={(event) => event.stopPropagation()} />
      </div>
      <div className={headerLabelClassName}>
        <span className={`text-sm font-medium ${headerLabelClassName} `}>{label}</span>
      </div>
    </div>
  );
};

interface Props {
  label: string;
  headerLabelClassName: string;
  hasError?: boolean;
}

export default DefaultHeaderDetails;
